<template>
  <div class="order-process">
    <div class="result" v-show="info.procs && info.procs.length !== 0">
      <div class="product-head">
        <span class="product-name pull-left">{{info.productName}}</span><span class="time pull-left">签约日期：{{info.signDate}}</span>
      </div>
      <table class="order-table">
        <tr class="table-head">
          <th>序号</th>
          <th>当前步骤</th>
          <th>完成时间</th>
        </tr>
        <tr class="table-body" v-for="(item, index) in info.procs" :key="index">
          <td>{{index+1}}</td>
          <td>{{item.step}}</td>
          <td>{{item.finishTime}}</td>
        </tr>
      </table>
    </div>
    <Loading
      v-show="!info.procs || info.procs.length === 0"
      :height="400"
      :is-no-more="noResult">
      <div class="no-result" slot="nomore">
        <div class="img"><img src="/static/img/noresult.png" alt=""></div>
        <div class="msg">
          <p>未查询到符合条件的借款进程...</p>
          <p>如有疑问可拨打 400-770-5127 咨询</p>
        </div>
        <div class="btn"><a href="javascript:;" @click="$router.go(-1)">返回</a></div>
      </div>
    </Loading>
  </div>
</template>

<script>

  import Loading from '@/components/combo/loading'
  export default {
    name: 'OrderProcess',
    components: {
      Loading
    },
    data () {
      return {
        info: {},
        noResult: false
      }
    },
    created () {
      this.no = this.$route.query.no
      this._fetchData()
    },
    methods: {
      _fetchData () {
        let vm = this
        let token = this.$store.state.token
        this.$http({
          url: '/center/getOrderProcess.jhtml',
          data: {
            uid: token.uid,
            no: this.no
          },
          done (info) {
            vm.info = info || {}
            if (!vm.info.procs || vm.info.procs.length === 0) {
              vm.noResult = true
            }
          },
          fail (m) {
            vm.$dialog(m, () => {
              vm.$router.replace('/u/order')
            })
          }
        })
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .product-head
    height 50px
    border-radius 25px
    background-color #fff
    line-height 50px
    padding 0 15px
    margin-bottom 8px
    display inline-block
    font-size 0
    vertical-align middle
    .product-name
      font-size 16px
      color #0068b7
      font-weight bold
      position relative
      padding-right 15px
      margin-right 15px
      &:after
        content ''
        position absolute
        right 0
        top 15px
        width 2px
        height 20px
        background #0068b7
    .time
      font-size 14px
      color #999
    .status
      font-size 14px
      margin-left 20px
    .delete
      font-size 14px
      color rgb(43, 158, 252)
      margin-left 10px
      text-decoration underline
  .order-table
    width 100%
    text-align center
    .table-head
      height 58px
      border-bottom 8px solid #f4faff
      background-color #fff
      font-weight bold
      height 50px
      line-height 50px
      font-size 16px
      th
        text-align center
    .table-body
      height 60px
      line-height 60px
      background-color #fff
      font-size 14px
      color #666
      strong
        color #333
      &:nth-child(2n+1)
        background-color #f4faff
      .opreation
        margin 0 10px
        &.detail
          color #0068b7
        &.process
          color #ff6926
  .no-result
    padding 100px 0
    margin 0 auto
    text-align center
    color #999
    .img
      margin-bottom 20px
    .msg
      font-size 14px
      line-height 30px
      p
        margin 0
    .btn
      margin-top 20px
      width 150px
      height 40px
      border-radius 5px
      font-size 16px
      background-color #0068b7
      padding 0
      border 0
      overflow hidden
      a
        display block
        width 100%
        height 100%
        line-height 40px
        text-decoration none
        color #fff
</style>



// WEBPACK FOOTER //
// order-process.vue?5e6b882e